import { render, staticRenderFns } from "./TabStorico.vue?vue&type=template&id=8bdd675a&"
import script from "./TabStorico.vue?vue&type=script&lang=js&"
export * from "./TabStorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/TabStorico.vue
// module id = 443
// module chunks = 0